import { PriceTable } from "../components/PriceTable";

export function HomePage() {
  return (
    <div className="page page-home page-home-kiosk">
      <div className="frame-9-16">
        <PriceTable displayMode="signage" />
      </div>
    </div>
  );
}
